import { Component } from "react";

import _ from "underscore";

export default class TableCellTerm extends Component {
  render() {
    let application = this.props.item;

    var acceptedOffer =
      application.LoanOffers.length > 0
        ? _.find(application.LoanOffers, (offer) => {
            return offer.Accepted == true;
          })
        : undefined;

    return (
      <div>
        Applied term: {application.AppliedTerm}
        {acceptedOffer ? ", Term chosen: " + acceptedOffer.LoanTerm : undefined}
      </div>
    );
  }
}
